import { useTranslation } from "@refinedev/core";
import DateTimePicker from "components/datetimePicker";
import Input from "components/input";
import { Label } from "components/label";
import { IAdditionalSetupForm, ISimpleEventDetail } from "interfaces";
import { get } from "lodash";
import moment from "moment";
import { Controller, useFormContext } from "react-hook-form";

export const ChangeDistance = ({
  isEdit,
}: {
  isEdit: boolean;
  eventDetailData: ISimpleEventDetail;
}) => {
  const { translate } = useTranslation();
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<IAdditionalSetupForm>(); // retrieve all hook methods

  return isEdit ? (
    <div className="box-container p-4 sm:p-6">
      <div className="grid gap-x-4 gap-y-6 sm:grid-cols-6 lg:gap-x-6">
        <div className="sm:col-span-3">
          <Label
            required
            id="change_distance.start_change_distance_date"
            name={translate(
              "eventSetup.additionalSetup.changeDistance.startDate"
            )}
          />
          <Controller
            control={control}
            name="change_distance.start_change_distance_date"
            render={({ field: { onChange, value = "" } }) => {
              return (
                <DateTimePicker
                  id="change_distance.start_change_distance_date"
                  placeholder={translate(
                    "eventSetup.additionalSetup.changeDistance.startDate"
                  )}
                  error={get(
                    errors,
                    `change_distance.start_change_distance_date.message`,
                    ""
                  )}
                  value={value}
                  onChange={(date: any) =>
                    date === null
                      ? onChange("")
                      : onChange(moment(date).format("YYYY-MM-DD HH:mm:ss"))
                  }
                />
              );
            }}
          />
          {get(errors, `change_distance.start_change_distance_date`, "") ? (
            <p className="error-text">
              <span className="font-medium">
                {get(
                  errors,
                  `change_distance.start_change_distance_date.message`,
                  ""
                )}
              </span>
            </p>
          ) : null}
        </div>
        <div className="sm:col-span-3">
          <Label
            required
            id="change_distance.end_change_distance_date"
            name={translate(
              "eventSetup.additionalSetup.changeDistance.endDate"
            )}
          />
          <Controller
            control={control}
            name="change_distance.end_change_distance_date"
            render={({ field: { onChange, value = "" } }) => {
              return (
                <DateTimePicker
                  id="change_distance.end_change_distance_date"
                  placeholder={translate(
                    "eventSetup.additionalSetup.changeDistance.endDate"
                  )}
                  error={get(
                    errors,
                    `change_distance.end_change_distance_date.message`,
                    ""
                  )}
                  value={value}
                  onChange={(date: any) =>
                    date === null
                      ? onChange("")
                      : onChange(moment(date).format("YYYY-MM-DD HH:mm:ss"))
                  }
                />
              );
            }}
          />
          {get(errors, `change_distance.end_change_distance_date`, "") ? (
            <p className="error-text">
              <span className="font-medium">
                {get(
                  errors,
                  `change_distance.end_change_distance_date.message`,
                  ""
                )}
              </span>
            </p>
          ) : null}
        </div>
        <div className="sm:col-span-3">
          <Label
            required
            id="change_distance.max_number_of_times_to_change_distance"
            name={translate(
              "eventSetup.additionalSetup.changeDistance.maxNumberOfTimes"
            )}
          />
          <Input
            id="change_distance.max_number_of_times_to_change_distance"
            type="number"
            placeholder={translate(
              "eventSetup.additionalSetup.changeDistance.maxNumberOfTimes"
            )}
            error={get(
              errors,
              "change_distance.max_number_of_times_to_change_distance"
            )}
            {...register(
              "change_distance.max_number_of_times_to_change_distance",
              {
                valueAsNumber: true,
              }
            )}
          />
          {get(
            errors,
            `change_distance.max_number_of_times_to_change_distance`,
            ""
          ) ? (
            <p className="error-text">
              <span className="font-medium">
                {get(
                  errors,
                  `change_distance.max_number_of_times_to_change_distance.message`,
                  ""
                )}
              </span>
            </p>
          ) : null}
        </div>
        <div className="sm:col-span-3">
          <Label
            required
            id="change_distance.change_distance_fee"
            name={translate(
              "eventSetup.additionalSetup.changeDistance.changeFee"
            )}
          />
          <Input
            id="change_distance.change_distance_fee"
            type="number"
            placeholder={translate(
              "eventSetup.additionalSetup.changeDistance.changeFee"
            )}
            error={get(errors, "change_distance.change_distance_fee")}
            {...register("change_distance.change_distance_fee", {
              valueAsNumber: true,
            })}
          />
          {get(errors, `change_distance.change_distance_fee`, "") ? (
            <p className="error-text">
              <span className="font-medium">
                {get(errors, `change_distance.change_distance_fee.message`, "")}
              </span>
            </p>
          ) : null}
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};
